import { fabric } from 'fabric';
import GifElement from '~/scripts/objects/gif';

fabric.GifElement = GifElement;

// Sample GIPHY URLs — public CDN, CORS-friendly, varying sizes.
const SAMPLES = {
    small: {
        label: 'Small (~50KB, Muybridge horse)',
        url: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Muybridge_horse_gallop_animated_2.gif',
    },
    medium: {
        label: 'Medium loop (~500KB)',
        url: 'https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif',
    },
    large: {
        label: 'Large GIF (~2MB)',
        url: 'https://media.giphy.com/media/26tn33aiTi1jkl6H6/giphy.gif',
    },
};

const state = {
    canvas: null,
    forceFallback: false,
    items: [], // { gif, backend }
    customUrl: '',
};

function $(id) {
    return document.getElementById(id);
}

function setupCanvas() {
    const cw = window.innerWidth;
    const ch = window.innerHeight - 80; // leave room for top bar
    const canvas = new fabric.Canvas('poc-canvas', {
        width: cw,
        height: ch,
        backgroundColor: '#1a1a2e',
        selection: false,
        preserveObjectStacking: true,
    });
    state.canvas = canvas;

    // Render-tracking for FPS
    let renderCount = 0;
    let lastSecond = performance.now();
    canvas.on('after:render', () => {
        renderCount++;
        const now = performance.now();
        if (now - lastSecond >= 1000) {
            const fps = (renderCount * 1000) / (now - lastSecond);
            $('fps').textContent = fps.toFixed(1);
            renderCount = 0;
            lastSecond = now;
        }
    });

    // Periodic memory display (Chrome only)
    setInterval(() => {
        if (performance.memory) {
            const mb = performance.memory.usedJSHeapSize / 1024 / 1024;
            $('mem').textContent = mb.toFixed(1) + ' MB';
        } else {
            $('mem').textContent = 'n/a';
        }
        $('count').textContent = state.items.length;
    }, 500);
}

function placeRandom(width, height) {
    const cw = state.canvas.getWidth();
    const ch = state.canvas.getHeight();
    return {
        left: Math.random() * Math.max(0, cw - width),
        top: Math.random() * Math.max(0, ch - height),
    };
}

function addGif(url) {
    const w = 240;
    const h = 240;
    const { left, top } = placeRandom(w, h);
    const gif = new GifElement(null, {
        left,
        top,
        width: w,
        height: h,
        customData: {
            gifSrc: url,
            forceFallback: state.forceFallback,
        },
    });
    state.canvas.add(gif);

    // Backend is determined async after detection — log when known.
    const start = performance.now();
    const checkBackend = setInterval(() => {
        if (gif.backend) {
            clearInterval(checkBackend);
            const ms = (performance.now() - start).toFixed(0);
            // eslint-disable-next-line no-console
            console.log(
                `[POC] gif loaded in ${ms}ms — backend: ${gif.backend}`,
                url
            );
            updateBackendList();
        }
    }, 50);

    state.items.push({ gif, url });
    updateBackendList();
}

function clearAll() {
    state.canvas.getObjects().forEach((o) => state.canvas.remove(o));
    state.items = [];
    updateBackendList();
}

function updateBackendList() {
    const counts = { 'image-decoder': 0, gifuct: 0, pending: 0 };
    state.items.forEach((it) => {
        const b = it.gif.backend || 'pending';
        counts[b] = (counts[b] || 0) + 1;
    });
    $('backends').textContent = `ImageDecoder: ${counts['image-decoder']} · gifuct: ${counts.gifuct} · pending: ${counts.pending}`;
}

function setupUI() {
    $('btn-small').addEventListener('click', () =>
        addGif(SAMPLES.small.url)
    );
    $('btn-medium').addEventListener('click', () =>
        addGif(SAMPLES.medium.url)
    );
    $('btn-large').addEventListener('click', () =>
        addGif(SAMPLES.large.url)
    );
    $('btn-clear').addEventListener('click', clearAll);
    $('btn-custom').addEventListener('click', () => {
        const url = $('custom-url').value.trim();
        if (url) addGif(url);
    });
    $('chk-fallback').addEventListener('change', (e) => {
        state.forceFallback = e.target.checked;
        $('mode').textContent = state.forceFallback
            ? 'gifuct (forced)'
            : 'auto';
    });

    // Show ImageDecoder availability once at start.
    if (typeof ImageDecoder === 'undefined') {
        $('id-support').textContent = 'NO (ImageDecoder undefined)';
    } else {
        ImageDecoder.isTypeSupported('image/gif')
            .then((ok) => {
                $('id-support').textContent = ok
                    ? 'YES'
                    : 'NO (isTypeSupported = false)';
            })
            .catch(() => {
                $('id-support').textContent = 'NO (detection error)';
            });
    }

    $('ua').textContent = navigator.userAgent;
}

document.addEventListener('DOMContentLoaded', () => {
    setupCanvas();
    setupUI();
});

window.addEventListener('resize', () => {
    if (state.canvas) {
        state.canvas.setWidth(window.innerWidth);
        state.canvas.setHeight(window.innerHeight - 80);
        state.canvas.requestRenderAll();
    }
});
